import { BUTTON_HEIGHT, FONT_SIZE, TEXT_SCALE_PROPS } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import styled from "styled-components";

export const Styles = styled.div<TEXT_SCALE_PROPS>`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  flex: 1;

  .list-tracking-header-bar {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 4px;
    padding: 0 4px;
  }

  .list-tracking-header-center {
    width: 100%;
    max-width: 100%;
    text-align: center;

    .title {
      font-size: ${({ text_scale }) =>
        FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]} !important;
      font-weight: 700;
      margin: 0;
      color: var(--color-item);
    }
  }

  .list-tracking-header-actions {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
  }

  .list-tracking-back-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 0px;
    border: none;
    border-radius: 8px;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    background: #5a67d8;
    color: #fff;

    &:hover {
      background: #6a78e8;
      color: #fff;
    }
  }

  .list-tracking-header-bar--desktop {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    min-height: auto;
    padding: 0;
    gap: 12px;
  }

  .list-tracking-header-bar--desktop .list-tracking-header-center {
    text-align: left;
    flex: 1;
    min-width: 0;
  }

  .list-tracking-header-bar--desktop .list-tracking-header-actions {
    position: relative;
    top: auto;
    right: auto;
    flex-shrink: 0;
  }

  .list-tracking-header-bar--desktop .list-tracking-header-center .title {
    text-align: left;
    font-size: 20px;
    color: var(--color-item);
  }

  .month-picker-wrap {
    width: fit-content;

    .desktop & {
      border: 1px solid #00000026;
      border-radius: 4px;
    }
  }

  .month-picker-wrap .ant-picker {
    min-height: 32px;
    width: 100%;
    padding: 3px 12px;
    background: var(--bg-field);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 8px;
  }

  .month-picker-wrap .ant-picker {
    &.ant-picker-disabled {
      opacity: 0.8;
      input {
        cursor: not-allowed;
      }
    }
    input {
      color: var(--color-field);
      font-size: ${({ text_scale }) =>
        FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]} !important;
      cursor: pointer;
    }
  }

  .month-picker-wrap .ant-picker {
    padding: 0px 12px !important;
    min-height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
  }
  .title_container,
  .ag-header-cell-text,
  .ag-ltr .ag-cell {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]} !important;
  }
  .ag-cell-label-container {
    padding: 0px !important;
  }

  @media screen and (max-width: 768px) {
    .month-picker-wrap .ant-picker input {
      font-size: 16px;
    }
  }

  .month-picker-wrap .ant-picker-suffix {
    color: rgba(255, 255, 255, 0.65);

    .desktop & {
      color: var(--color-item);
    }
  }

  .ant-picker {
    background: var(--bg-field);
    input {
      color: var(--color-field);
    }
    color: var(--color-field);
  }
`;
